import _ from 'lodash';

import {
  useCallback,
  useMemo
} from 'react';
import {
  ImportSubsidiaryInput,
  useImportNetSuiteSubsidiariesMutation
} from 'generated/graphql';

import { ImportCsvModal } from 'iron-forge-react-modules';
import * as types from './types';



export type IColumnDef = ImportCsvModal.IColumnDescription<types.NetSuiteSubsidiariesPropertyName>;



export const columnDefs: IColumnDef[] = [
  {
    id: 'Internal ID',
    label: 'Internal ID',
    isRequired: true,
    formatType: undefined
  },
  {
    id: 'Name',
    label: 'Name',
    isRequired: true,
    formatType: undefined
  }
];



export function useImportNetSuiteSubsidiariesFromCsv() {
  const [fnMutate, tuple] = useImportNetSuiteSubsidiariesMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = useCallback(
    (rows: Array<_.Dictionary<string>>) => {
      const input = __formatTransform(rows);

      fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}



function __formatTransform(rawCsvRows: Array<_.Dictionary<string>>): ImportSubsidiaryInput[] {
  const rowsAsPropertyName2Value: ImportSubsidiaryInput[] = _.map(rawCsvRows, row => {
    return {
      netSuiteInternalId: row['Internal ID'],
      name: row['Name']
    };
  });

  return rowsAsPropertyName2Value;
}
